import React, { Component } from 'react';
import v from 'vudu';
import { withRouter } from 'react-router-dom';
import isSafariIOS from 'utils/isSafariIOS';
import Wave from 'lib/Wave';
const THREE = window.THREE;

function webglAvailable() {
  try {
    let canvas = document.createElement("canvas");
    return !!
        window.WebGLRenderingContext &&
        (canvas.getContext("webgl") ||
            canvas.getContext("experimental-webgl"));
  } catch(e) {
    return false;
  }
}

const localClasses = v({
  waveBackground: {
    willChange: 'transform',
    opacity: 0.4,
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100vh',
    backgroundColor: '#1D0918',
    backgroundImage: 'linear-gradient(0deg, #1D0918 0%, #0F061B 100%)',
    zIndex: -1,
    '@media (min-width: 1800px)': {
      display: 'none'
    }
  }
});

export default withRouter(class WaveBackground extends Component {
  componentDidMount() {
    if (isSafariIOS()) return null;
    if (!webglAvailable()) return null;

    this.wave = new Wave();
    this.wave.init();
    window.addEventListener("resize", this.wave.resize);

    if (this.props.location.pathname === "/bonus") {
      this.wave.terrain.uniforms.line_color.value = new THREE.Color('#1CACF3');
    }
  }

  componentWillReceiveProps(nextProps) {
    if (isSafariIOS()) return null;
    if (!webglAvailable()) return null;

    if (nextProps.location.pathname === "/bonus") {
      this.wave.terrain.uniforms.line_color.value = new THREE.Color('#1CACF3');
    } else {
      this.wave.terrain.uniforms.line_color.value = new THREE.Color('#FF387A');
    }
  }

  render() {
    if (isSafariIOS()) return null;
    if (!webglAvailable()) return null;

    return <div id='experience' className={localClasses.waveBackground}></div>;
  }
});



// WEBPACK FOOTER //
// ./src/components/WaveBackground.js